// import React, { useState } from 'react';

// const ServicesSection = () => {
//   const [modalOpen, setModalOpen] = useState(false);

//   const handleModalToggle = () => {
//     setModalOpen(!modalOpen);
//   };

//   return (
//     <section className="hm8ServiceSection">
//       <div className="">
        
//         <div className="col-md-12 col-sm-12  videoServiceRight ">
//   <div className="home8Title">
//     <h3>OUR SERVICES</h3>
//     <h1>Our Company Services</h1>
//   </div>
//   <div className="col-md-12 col-sm-12 col-xs-12">
//     <div className="home8Services">
//       <div className="row">
//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/oil-ylw.png" alt="Aluminium Glass Office Partition" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>Aluminium Glass Office Partition</h5>
//               </a>
//               <p>Expertly designed office partitions made from high-quality aluminium glass materials.</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/material-ylw.png" alt="Toughened Glass Work" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>Toughened Glass Work</h5>
//               </a>
//               <p>High-grade toughened glass solutions for durability and modern aesthetics.</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/energy-ylw.png" alt="ACP Cladding Panel Installation" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>ACP Cladding Panel Installation</h5>
//               </a>
//               <p>Professional ACP cladding panel installations for sleek and stylish exteriors.</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/manufactur-ylw.png" alt="Bird Net Installation" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>Bird Net Installation</h5>
//               </a>
//               <p>Effective bird net solutions to ensure a safe and clean environment.</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/oil-ylw.png" alt="Invisible Grill Installation" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>Invisible Grill Installation</h5>
//               </a>
//               <p>Secure and aesthetically pleasing invisible grills for your home and office.</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/material-ylw.png" alt="MS Fabrication Work" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>MS Fabrication Work</h5>
//               </a>
//               <p>
//                 Custom MS fabrication solutions including doors, shades, grills, and industrial structures.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/energy-ylw.png" alt="Furniture Work" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>Furniture Work</h5>
//               </a>
//               <p>High-quality, custom furniture designs for residential and industrial purposes.</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-4 col-sm-6 col-xs-12">
//           <div className="hm8singleService">
//             <div className="hm8serviceImgArea">
//               <img src="images/home8-images/manufactur-ylw.png" alt="Renovation and Ceiling Work" />
//             </div>
//             <div className="hm8serviceContent">
//               <a href="#">
//                 <h5>Renovation and Ceiling Work</h5>
//               </a>
//               <p>Comprehensive renovation and foil ceiling solutions for homes and offices.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
//   <div className="col-md-2 col-sm-12 col-xs-12"></div>
// </div>

//       </div>
//     </section>
//   );
// };

// export default ServicesSection;




import React from "react";

const ServicesSection = () => {
  const services = [
    { title: "All types of aluminium glass office partition", icon: "fa fa-building" },
    { title: "All types of toughened glass work", icon: "fa fa-window-maximize" },
    { title: "Door partition", icon: "fa fa-door-closed" },
    { title: "ACP cladding panel installation", icon: "fa fa-clone" },
    { title: "Aluminium glass window", icon: "fa fa-window-restore" },
    { title: "Soundproof glass window", icon: "fa fa-volume-mute" },
    { title: "Aluminium mosquito net", icon: "fa fa-bug" },
    { title: "Bird net installation", icon: "fa fa-dove" },
    { title: "Invisible grill installation", icon: "fa fa-bars" },
    { title: "MS fabrication door", icon: "fa fa-tools" },
    { title: "MS Fabrication Industrial Shade", icon: "fa fa-hard-hat" },
    { title: "MS Fabrication Grill Window", icon: "fa fa-shield-alt" },
    { title: "Furniture Work", icon: "fa fa-couch" },
    { title: "All types of industrial fabrication work", icon: "fa fa-cogs" }, // New service
    { title: "All types of home renovation work", icon: "fa fa-home" }, // New service
    { title: "All types of kitchen aluminium profile work", icon: "fa fa-utensils" }, // New service
    { title: "All types of painting work", icon: "fa fa-paint-brush" }, // New service
    { title: "Foil ceiling work", icon: "fa fa-cloud" }, // New service
  ];
  
  

  return (
    <section className="hm8ServiceSection">
      <div className="">
        <div className="videoServiceRight">
          <div className="home8Title text-center">
            <h3>OUR SERVICES</h3>
            <h1>Our Company Services</h1>
          </div>
          <div className="home8Services">
            <div className="row">
              {services.map((service, index) => (
                <div
                  className="col-md-4 col-sm-6 col-xs-12 mb-4"
                  key={`service-${index}`}
                >
                  <div className="hm8singleService">
                    <div className="hm8serviceIconArea text-center">
                      <i className={`fa ${service.icon} fa-3x orcolor`}></i>
                    </div>
                    <div className="hm8serviceContent">
                      <a href="#">
                        <h5>{service.title}</h5>
                      </a>
                      <p className="">
                        We offer top-notch solutions for{" "}
                        <span>{service.title}</span>. Our expertise ensures quality and
                        precision in every project we undertake.
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
